import axiosClient from 'utils/axiosClient';
import api from 'api';

const getBenefitDemand = async (params?: any) => {
	const response = await axiosClient.get(api.RATING_REPORTS.BENEFIT_DEMAND, {params});
	return response.data;
};

const getBenefitsSummary = async (params?: any) => {
	const response = await axiosClient.get(api.RATING_REPORTS.BENEFITS_SUMMARY, {params});
	return response.data;
};

const getStudentsActivity = async (params?: any) => {
	const response = await axiosClient.get(api.RATING_REPORTS.STUDENTS_ACTIVITY, {params});
	return response.data;
};

const getStudentHistory = async (studentID: number, params?: any) => {
	const response = await axiosClient.get(api.RATING_REPORTS.STUDENT_HISTORY + studentID + '/history', {params});
	return response.data;
};

export default {
	getBenefitDemand,
	getBenefitsSummary,
	getStudentsActivity,
	getStudentHistory
};
